import { lazy, Suspense } from "react";

const LoyaltyWalletMainPage = lazy(() =>
  import("../screens/LoyaltyWallet/LoyaltyWalletMainPage")
);

const LoyaltyRoutes = {
  path: "loyalty",
  children: [
    {
      path: "wallet",
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <LoyaltyWalletMainPage />
        </Suspense>
      ),
    },
  ],
};

export default LoyaltyRoutes;
